import { supabase } from './supabaseClient';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  const base = token ? { Authorization: `Bearer ${token}` } : {};
  // 🍎 IAP grace header — pendant 30 minutes après un achat IAP réussi
  // (flag posé par Pricing.jsx), on annonce au backend qu'un paiement
  // Apple a eu lieu. Le backend l'accepte comme preuve TEMPORAIRE (30
  // min) en l'absence d'une subscription synchronisée — couvre le délai
  // du webhook RevenueCat (souvent quelques secondes, parfois minutes
  // en sandbox). Le webhook finit toujours par fire et écrit le vrai
  // statut. Cette fenêtre courte limite tout risque d'abus.
  try {
    const ts = window.localStorage.getItem('sp.iapPurchased.v1');
    if (ts) {
      const age = Date.now() - Number(ts);
      if (age >= 0 && age <= 30 * 60 * 1000) {
        base['X-IAP-Recent'] = String(ts);
      }
    }
  } catch { /* localStorage disabled */ }
  return base;
}

async function call(path, opts = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(await authHeaders()),
    ...(opts.headers || {}),
  };
  const res = await fetch(`${BACKEND}/api${path}`, { ...opts, headers });
  if (!res.ok) {
    let detail = res.statusText;
    const status = res.status;
    const text = await res.text();
    if (text) {
      try {
        detail = JSON.parse(text).detail || detail;
      } catch {
        detail = text.slice(0, 200) || detail;
      }
    }
    const err = new Error(detail);
    err.status = status;
    throw err;
  }
  return res.json();
}

async function callMultipart(path, formData) {
  const headers = {
    ...(await authHeaders()),
  };
  const res = await fetch(`${BACKEND}/api${path}`, {
    method: 'POST',
    headers,
    body: formData,
  });
  if (!res.ok) {
    let detail = res.statusText;
    const status = res.status;
    const text = await res.text();
    if (text) {
      try {
        detail = JSON.parse(text).detail || detail;
      } catch {
        detail = text.slice(0, 200) || detail;
      }
    }
    const err = new Error(detail);
    err.status = status;
    throw err;
  }
  return res.json();
}

export const suppliersApi = {
  list: () => call('/suppliers'),
  create: (payload) =>
    call('/suppliers', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
  update: (id, payload) =>
    call(`/suppliers/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    }),
  remove: (id) =>
    call(`/suppliers/${id}`, {
      method: 'DELETE',
    }),
  listPrices: (id) => call(`/suppliers/${id}/prices`),
  uploadPriceList: (id, file, replace = true) => {
    const fd = new FormData();
    fd.append('file', file);
    return callMultipart(`/suppliers/${id}/upload?replace=${replace ? 'true' : 'false'}`, fd);
  },
  updatePrice: (priceId, payload) =>
    call(`/suppliers/prices/${priceId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    }),
  removePrice: (priceId) =>
    call(`/suppliers/prices/${priceId}`, {
      method: 'DELETE',
    }),
};
